<template>
  <ResizablePage>
    <template v-slot:content="conentProps">
      <v-container fluid v-bind:style="{ height: conentProps.tableHeight + 'px' }" class="overflow-y-auto" fill-height>
        <v-layout justify-center>
          <v-row style="max-width: 900px">
            <validation-observer style="width: 100%"
                                 class="px-5"
                                 ref="form_validation"
            >
              <v-form
                @submit.prevent="submit"
                :readonly="!editable">

                <v-expansion-panels multiple flat hover v-model="panels">
                  <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t("view.special-access.group.base") }}</v-expansion-panel-header>
                    <v-expansion-panel-content>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.special-access.first_name"
                            rules="max:100"
                          >
                            <v-text-field
                              v-model="firstName"
                              :counter="100"
                              :error-messages="errors"
                              :label="$t('view.special-access.first_name')"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.special-access.last_name"
                            rules="required|max:100"
                          >
                            <v-text-field
                              v-model="lastName"
                              :counter="100"
                              :error-messages="errors"
                              :label="$t('view.special-access.last_name')"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            :name="$t('view.special-access.access')"
                            rules=""
                          >
                            <v-select
                              v-model="access"
                              :items="accessItems"
                              :label="$t('view.special-access.access')"
                              :error-messages="errors"
                              :clearable="editable"
                              :disabled="!newObject"
                            >
                              <template v-slot:selection="data">
                                {{ $t("enum.person_access." + data.item) }}
                              </template>
                              <template v-slot:item="data">
                                {{ $t("enum.person_access." + data.item) }}
                              </template>
                            </v-select>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.special-access.login"
                            rules="required|max:50"
                          >
                            <v-text-field
                              v-model="login"
                              :counter="50"
                              :error-messages="errors"
                              :label="$t('view.special-access.login')"
                              required
                              autocomplete="off"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.special-access.password"
                            rules="min:8|max:50"
                          >
                            <v-text-field
                              v-model="password"
                              type="password"
                              :counter="50"
                              :error-messages="errors"
                              :label="$t('view.special-access.password')"
                              required
                              autocomplete="new-password"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <v-checkbox
                            v-model="active"
                            :value="active"
                            :label="$t('view.special-access.active')"
                            class="mt-0"
                            type="checkbox"
                          />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel v-if="access === 'collective'">
                    <v-expansion-panel-header>
                      {{ $t("view.special-access.group.vehicles") }}
                      <v-spacer />
                      <v-btn v-on:click.stop="findVehicleDialog"
                             small
                             elevation="0"
                             max-width="100px"
                             class="mr-4"
                             color="primary">
                        {{ $t("view.special-access.add_vehicle") }}
                      </v-btn>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12">
                          <v-list>
                            <v-list-item v-for="item in vehicles" :key="item.vehicleId" link>
                              <v-list-item-title style="max-width: 100px">{{ item.numericPlate }}</v-list-item-title>
                              <v-list-item-title>{{ item.companyName }}</v-list-item-title>
                              <v-list-item-subtitle>{{ item.deviceSerialNumber }}</v-list-item-subtitle>
                              <v-list-item-action>
                                <v-tooltip bottom open-delay="500">
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon
                                           @click="removeVehicle(item.vehicleId)"
                                           v-on="on"
                                           v-if="editable">
                                      <v-icon color="grey lighten-1">delete</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{ $t("view.special-access.tooltip.remove_vehicle") }}</span>
                                </v-tooltip>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                </v-expansion-panels>
              </v-form>
            </validation-observer>
          </v-row>
        </v-layout>

        <v-snackbar
          v-model="showError"
          bottom
          light
          timeout="-1"
          color="red lighten-4"
        >
          {{ errorMessage }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="indigo"
              text
              v-bind="attrs"
              @click="showError = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
        <FindVehicleDialog ref="findVehicleDialog" v-on:selected="vehicleSelected" />
      </v-container>
    </template>
  </ResizablePage>
</template>

<script>
import utils from "@/utils";
import ResizablePage from "@/components/ResizablePage";
import FindVehicleDialog from "@/components/dialogs/FindVehicleDialog";

export default {
  name: "SpecialAccessView",
  components: { ResizablePage, FindVehicleDialog },
  data() {
    return {
      editable: this.$store.state.auth.token.superuser,
      canLeave: !this.$store.state.auth.token.superuser,
      panels: [0],
      accessItems: ["superuser", "collective"],
      newObject: true,

      firstName: null,
      lastName: "",
      access: null,
      login: null,
      password: null,
      active: true,

      vehicles: null,

      showError: false,
      errorMessage: null,

      record: null
    };
  },

  methods: {
    async store() {
      if (await this.$refs.form_validation.validate()) {

        let object = {
          firstName: this.firstName,
          lastName: this.lastName,
          access: this.access,
          login: utils.nullString(this.login),
          password: utils.nullString(this.password),
          active: this.active,
          vehicles: this.vehicles
        };

        let params = {
          module: "special-access",
          object: object
        };

        if (!utils.isObjectEmpty(this.$store.state.data.record)) {
          params.id = this.record.personId;
          object.personId = this.record.personId;
          object.lastChange = this.record.lastChange;
        }

        let response = await this.$store.dispatch("data/storeRecord", params);

        if (response.error) {
          this.showError = true;
          this.errorMessage = response.message;
        } else {
          this.canLeave = true;
          this.$router.close({ name: "data/special-accesses" });
        }
      }
    },

    async remove() {
      let params = {
        module: "special-access",
        id: this.record.personId
      };

      let response = await this.$store.dispatch("data/deleteRecord", params);

      if (response.error) {
        this.showError = true;
        this.errorMessage = response.message;
      } else {
        this.canLeave = true;
        this.$router.close({ name: "data/special-accesses" });
      }
    },

    cancel() {
      this.canLeave = true;
      this.$router.close({ name: "data/special-accesses" });
    },

    vehicleSelected(vehicle) {
      this.vehicles.push(vehicle);
    },

    removeVehicle(vehicleId) {
      this.vehicles = this.vehicles.filter(x => x.vehicleId !== vehicleId);
    },

    findVehicleDialog() {
      this.$refs.findVehicleDialog.open();
    }
  },

  watch: {
    "$store.state.data.record": function() {
      if (this.$store.state.data.module === "special-access" && this.$store.state.data.record !== null) {
        let record = this.$store.state.data.record;

        if (record.personId === undefined) {
          this.firstName = null;
          this.lastName = null;
          this.access = null;
          this.login = null;
          this.password = null;
          this.active = true;
          this.vehicles = [];

          this.newObject = true;
        } else {
          this.firstName = record.firstName;
          this.lastName = record.lastName;
          this.access = record.access;
          this.login = record.login;
          this.password = record.password;
          this.active = record.active;
          this.vehicles = record.vehicles || [];

          this.newObject = false;
        }

        this.record = record;
      }
    },

    "$store.state.data.activeEvent": function() {
      const e = this.$store.state.data.activeEvent;
      if (e != null && e.target === "view") {

        try {
          if (e.click !== undefined) {
            switch (e.click) {
              case "store":
                this.store();
                break;
              case "cancel":
                this.cancel();
                break;
              case "delete":
                this.remove();
                break;
            }
          }
        } finally {
          this.$store.dispatch("data/processEvents");
        }
      }
    }
  },

  mounted() {
    this.$store.dispatch("data/resetEvents");

    if (this.$route.params.id === "new")
      this.$store.dispatch("data/fetchRecord", { module: "special-access" });
    else
      this.$store.dispatch("data/fetchRecord", { module: "special-access", id: this.$route.params.id });
  },

  async beforeRouteLeave(to, from, next) {
    if (this.canLeave)
      next();
    else {
      const answer = window.confirm(this.$t("view.leave_msg"));
      if (answer) {
        next();
      } else {
        next(false);
      }
    }
  }
};
</script>

<style scoped>

</style>